import React, { Component, useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Switch,
  Navigate,
} from "react-router-dom";
import { AppContext } from "./context";

// function ProtectedRoute({ ...rest }) {
//   const appdata = useContext(AppContext);
//   // const [isAuth, setIsAuth] = appdata[7];
//   // console.log(isAuth);
//   // const navigate = useNavigate();
//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         if (isAuth === false) {
//           // navigate.push("/");
//           return <Navigate to={{ pathname: "/" }} />;
//         }
//         // check if route is restricted by role
//         // if (roles === "L1" || roles === "L2") {
//         //   // role not authorised so redirect to dashboard
//         //   return <Navigate to={{ pathname: "/" }} />;
//         // }
//         return <Component {...props} />;
//       }}
//     />
//   );
// }
const ProtectedRoute = ({ isAuth, roles, children }) => {
  if (!isAuth) {
    return <Navigate to="/" replace />;
  }
  if (roles === "L1" || roles === "L2") {
    // role not authorised so redirect to dashboard
    return <Navigate to={{ pathname: "/" }} />;
  }
  return children;
};

export default ProtectedRoute;
